import Image from "next/image";

export function Logo({ variant = "dark", className }) {
  const src =
    variant === "light"
      ? "/logo-ledgerowl-white.svg"
      : "/logo-ledgerowl.svg";

  return (
    <Image
      priority
      src={src}
      alt="Logo Ledgerowl Main"
      width={110}
      height={0}
      className={className}
    />
  );
}
